import './styles.scss';

import React, {useState} from 'react';
import {Switch, Route} from 'react-router-dom';
import {Tabs} from "antd";
import BrowserRouter, {BrowserRoutes} from "../../routes/BrowserRouter";
import moment from "moment";
import AlertDetails from "../../components/specific/Alerts.details/Alerts.details";
import AnalyticsApi from "../../api/Analytics/Analytics.api";
import useUserStore from "../../data/User.store";
import {useQuery} from "react-query";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import ContractReportsContainer from "../../containers/Reports.Contract.Weekly/Reports.Contract.Weekly.container";

interface Props {
    userId?: string,
}

function Dashboard({userId}: Props) {
    const {user} = useUserStore();
    const [activeTab, setActiveTab] = useState('alertDetails');

    const {isLoading:alertDetailsIsLoading, data:alertDetailsData} = useQuery([
        'dashboardAnalyticsAlertDetails',
        isCurrentUser() ? user.id : parseInt(userId),
    ], AnalyticsApi.getPreviousDayDashboardForUser);

    if (alertDetailsIsLoading || !alertDetailsData) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text='Loading your personalized dashboard...'/>
            </div>
        )
    }

    function isCurrentUser() {
        return !userId;
    }

    let yesterday = moment().subtract(1, 'days');

    function onTabChange(key: string) {
        setActiveTab(key);
    }

    return (
        <div className='dashboard'>
            <div className='dashboard-header'>
                <div className='dashboard-header-title'>
                    <div className='left'>
                        {yesterday.format("MMM DD, YYYY")} At a Glance
                    </div>
                    <div className='right' 
                        onClick={
                            () => isCurrentUser() ? 
                            BrowserRouter.push(BrowserRoutes.alerts) : BrowserRouter.push(`${BrowserRoutes.getUsersById(parseInt(userId))}/alerts `)
                    }>
                        View all alerts
                    </div>
                </div>
            </div>
            <div className='dashboard-content'>
                <Switch>
                    <Route render={({match}) => (
                        <Tabs defaultActiveKey={activeTab} onChange={onTabChange}>
                            <Tabs.TabPane tab="Opportunities" key="alertDetails">
                                <AlertDetails alertAnalytics={alertDetailsData}/>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Weekly Contracts" key="weeklyContracts">
                                <ContractReportsContainer userId={isCurrentUser() ? user.id : parseInt(userId)}/>
                            </Tabs.TabPane>
                        </Tabs>
                    )}/>
                </Switch>
            </div>
        </div>
    )
}

export default Dashboard;